import { ProgrammePage } from '@interfaces';

interface ProgrammeGenreFilterOption {
	id: string;
	label: string;
	filterValue?: string;
}

export interface ProgrammeGenreFilter {
	id: string;
	label: string;
	filterParameter: 'genre';
	options: ProgrammeGenreFilterOption[];
}

export function getProgrammeGenreFilter(
	programme: ProgrammePage,
): ProgrammeGenreFilter | undefined {
	const filterOptions = programme.genreFilterOptions.filter(
		(filterOption) => filterOption.filterValue.length,
	);

	if (!filterOptions.length) return;

	return {
		id: 'genre-filter',
		label: 'Genre',
		filterParameter: 'genre',
		options: [
			{
				id: 'genre-filter-all',
				label: 'All',
				filterValue: undefined,
			},
			...filterOptions.map((option) => ({
				id: `genre-filter-${option.id}`,
				label: option.title,
				filterValue: option.filterValue,
			})),
		],
	};
}
